function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Artboard 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "TAS"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M10,0.5h24.9v6.5h-8.3V27h-8.2V7.1H10V0.5z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M49.6,22.6h-9.3L39,27h-8.4l10-26.5h8.9l10,26.5h-8.6L49.6,22.6z M47.9,16.9L45,7.4l-2.9,9.5H47.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M57.7,18.2l7.8-0.5c0.2,1.3,0.5,2.2,1,2.9c0.8,1.1,2,1.6,3.6,1.6c1.2,0,2.1-0.3,2.7-0.8 c0.6-0.5,0.9-1.2,0.9-1.9c0-0.7-0.3-1.3-0.9-1.8s-2-1.1-4.2-1.5c-3.6-0.8-6.1-1.9-7.7-3.2c-1.5-1.3-2.3-3-2.3-5.1 c0-1.4,0.4-2.6,1.2-3.9c0.8-1.2,2-2.2,3.6-2.9c1.6-0.7,3.8-1,6.5-1c3.4,0,6,0.6,7.7,1.9c1.8,1.3,2.8,3.3,3.2,6l-7.7,0.5 c-0.2-1.2-0.6-2.1-1.3-2.6C71.2,5.3,70.3,5,69.1,5c-1,0-1.7,0.2-2.2,0.6s-0.7,0.9-0.7,1.5c0,0.4,0.2,0.8,0.6,1.1 c0.4,0.3,1.3,0.7,2.7,1c3.6,0.8,6.1,1.6,7.7,2.3c1.5,0.8,2.7,1.8,3.4,2.9c0.7,1.2,1.1,2.5,1.1,3.9c0,1.7-0.5,3.3-1.4,4.7 c-0.9,1.4-2.3,2.5-3.9,3.3c-1.7,0.7-3.8,1.1-6.4,1.1c-4.5,0-7.6-0.9-9.4-2.6S57.9,20.9,57.7,18.2z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "B_C_T_C"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1.8,0.5h3.3c0.6,0,1,0.1,1.3,0.4s0.4,0.6,0.4,1c0,0.3-0.1,0.6-0.3,0.9C6.3,3,6.1,3.1,5.8,3.2 c0.4,0.1,0.7,0.3,0.9,0.5S7,4.3,7,4.6C7,4.9,7,5.2,6.8,5.4S6.5,5.8,6.3,6C6.1,6.1,5.9,6.1,5.6,6.2C5.2,6.2,4.9,6.2,4.8,6.2H1.8 V0.5z M3.5,2.8h0.8c0.3,0,0.5,0,0.6-0.1S5,2.4,5,2.2C5,2,5,1.9,4.9,1.8S4.6,1.7,4.3,1.7H3.5V2.8z M3.5,5h0.9C4.7,5,5,5,5.1,4.9 s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S4.7,3.9,4.4,3.9H3.5V5z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M5.6,10.9l1.6,0.5c-0.1,0.4-0.3,0.8-0.5,1.1S6.1,13,5.8,13.1S5,13.3,4.5,13.3c-0.6,0-1.1-0.1-1.5-0.3 s-0.7-0.5-1-1c-0.3-0.5-0.4-1-0.4-1.7c0-0.9,0.3-1.7,0.8-2.2c0.5-0.5,1.2-0.8,2.1-0.8c0.7,0,1.3,0.1,1.7,0.4s0.7,0.7,0.9,1.3 L5.5,9.6C5.4,9.4,5.4,9.3,5.3,9.2C5.2,9,5.1,8.9,5,8.9S4.7,8.8,4.5,8.8c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.2-0.2,0.6-0.2,1.1 c0,0.6,0.1,1.1,0.3,1.3C3.8,11.9,4.1,12,4.4,12c0.3,0,0.6-0.1,0.8-0.3S5.5,11.3,5.6,10.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1.6,14.5h5.4v1.4H5.1v4.3H3.4v-4.3H1.6V14.5z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M5.6,24.9l1.6,0.5c-0.1,0.4-0.3,0.8-0.5,1.1S6.1,27,5.8,27.1S5,27.3,4.5,27.3c-0.6,0-1.1-0.1-1.5-0.3 s-0.7-0.5-1-1c-0.3-0.5-0.4-1-0.4-1.7c0-0.9,0.3-1.7,0.8-2.2c0.5-0.5,1.2-0.8,2.1-0.8c0.7,0,1.3,0.1,1.7,0.4s0.7,0.7,0.9,1.3 l-1.6,0.3c-0.1-0.2-0.1-0.3-0.2-0.4C5.2,23,5.1,22.9,5,22.9s-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.2-0.2,0.6-0.2,1.1 c0,0.6,0.1,1.1,0.3,1.3C3.8,25.9,4.1,26,4.4,26c0.3,0,0.6-0.1,0.8-0.3S5.5,25.3,5.6,24.9z"
})))));

var SvgBctcTasSimpleLogo = function SvgBctcTasSimpleLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83.2 27.6",
    style: {
      enableBackground: "new 0 0 83.2 27.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBctcTasSimpleLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bctc-tas-simple-logo.e8bf4e8c.svg";
export { ForwardRef as ReactComponent };